(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apps"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = 'nd-instafeed';
  let restarting = false;
  const restore = element => {
    const template = element.querySelector('template[data-nd-instafeed]');
    if (!template) return;
    element.replaceChildren(template.content.cloneNode(true));
    element.querySelectorAll('script').forEach(original => {
      const script = document.createElement('script');
      Array.from(original.attributes).forEach(attribute => script.setAttribute(attribute.name, attribute.value));
      script.textContent = original.textContent;
      original.replaceWith(script);
    });
    element.style.minHeight = '';
  };
  const start = () => {
    if (restarting) return;
    restarting = true;
    document.querySelectorAll(selector).forEach(restore);
    if (document.readyState === 'loading') return;
    const original = document.querySelector('script[src*="gsc-instafeed-widget.js"]');
    if (!original) return;
    if (!window.GSC_INSTAFEED_RUNTIME && !window.GSC_INSTAFEED_BUILD) {
      if (!original.dataset.ndFeedLoaded) {
        original.addEventListener('load', () => { original.dataset.ndFeedLoaded = 'true'; }, { once: true });
        return;
      }
    }
    const script = document.createElement('script');
    script.src = original.src;
    script.async = true;
    if (original.crossOrigin) script.crossOrigin = original.crossOrigin;
    if (original.nonce) script.nonce = original.nonce;
    document.head.appendChild(script);
  };
  const setup = root => {
    const elements = Array.from(root.querySelectorAll(selector)).filter(element => !element.dataset.ndReady);
    if (!elements.length) return;
    elements.forEach(element => { element.dataset.ndReady = 'true'; });
    if (window.Shopify?.designMode || !document.querySelector('script[src*="gsc-instafeed-widget.js"]') || !window.matchMedia('(max-width: 989px)').matches || !('IntersectionObserver' in window)) {
      elements.forEach(restore);
      if (document.readyState !== 'loading') start();
      return;
    }
    const observer = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      observer.disconnect();
      start();
    }, { rootMargin: '400px 0px' });
    elements.forEach(element => {
      const template = element.querySelector('template[data-nd-instafeed]');
      const widget = template?.content.querySelector('.gfa-widget');
      if (!widget || !Array.from(widget.classList).some(name => name.startsWith('GSC-')) || /\bconst\s+mf\s*=\s*(?:null|\[\s*\])\s*;/.test(template.innerHTML)) {
        restore(element);
        return;
      }
      element.style.minHeight = 'min(135vw, 720px)';
      observer.observe(element);
    });
    const media = window.matchMedia('(max-width: 989px)');
    media.addEventListener?.('change', event => { if (!event.matches) { observer.disconnect(); start(); } }, { once: true });
  };
  if (!customElements.get(selector)) customElements.define(selector, class extends HTMLElement {
    connectedCallback() { setup(this.parentElement); }
  });
  document.addEventListener('shopify:section:load', event => { restarting = false; setup(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nd-hero"] && !Shopify.designMode) return;
  try {
    
(function(){function init(root){if(!root||root.dataset.ready==="1")return;root.dataset.ready="1";var slides=[].slice.call(root.querySelectorAll(".ndh__slide"));var dots=[].slice.call(root.querySelectorAll("[data-dot]"));var i=0,timer=null,startX=0;function clamp(value,min,max){if(max<min)return(min+max)/2;return Math.min(Math.max(value,min),max)}function positionContent(slide){if(!slide)return;var content=slide.querySelector(".ndh__content");if(!content)return;var isMobile=window.innerWidth<750;var x=parseFloat(isMobile?slide.dataset.contentXMobile:slide.dataset.contentX);var y=parseFloat(isMobile?slide.dataset.contentYMobile:slide.dataset.contentY);if(!isFinite(x))x=isMobile?50:28;if(!isFinite(y))y=isMobile?60:50;content.style.setProperty("--ndh-safe-scale","1");var rw=root.clientWidth;var rh=root.clientHeight;var cw=content.offsetWidth;var ch=content.offsetHeight;var margin=isMobile?14:window.innerWidth<1100?22:32;var availableW=Math.max(1,rw-margin*2);var availableH=Math.max(1,rh-margin*2);var scale=Math.min(1,availableW/Math.max(cw,1),availableH/Math.max(ch,1));scale=Math.max(scale,.72);content.style.setProperty("--ndh-safe-scale",String(scale));var scaledW=cw*scale;var scaledH=ch*scale;var desiredX=rw*(x/100);var desiredY=rh*(y/100);var minX=margin+scaledW/2;var maxX=rw-margin-scaledW/2;var minY=margin+scaledH/2;var maxY=rh-margin-scaledH/2;content.style.left=clamp(desiredX,minX,maxX)+"px";content.style.top=clamp(desiredY,minY,maxY)+"px"}function positionAll(){slides.forEach(positionContent)}positionAll();var resizeTimer=null;window.addEventListener("resize",function(){clearTimeout(resizeTimer);resizeTimer=setTimeout(positionAll,50)},{passive:true});if("ResizeObserver"in window){var ro=new ResizeObserver(function(){positionAll()});ro.observe(root);slides.forEach(function(slide){var content=slide.querySelector(".ndh__content");if(content)ro.observe(content)})}if(slides.length<2)return;var autoplay=root.dataset.autoplay==="true"&&root.dataset.designMode!=="true";var delay=parseInt(root.dataset.delay,10)||5e3;function show(n){if(n<0)n=slides.length-1;if(n>=slides.length)n=0;slides.forEach(function(slide,x){var active=x===n;slide.classList.toggle("is-active",active);slide.setAttribute("aria-hidden",active?"false":"true");slide.inert=!active});dots.forEach(function(dot,x){var active=x===n;dot.classList.toggle("is-active",active);dot.setAttribute("aria-current",active?"true":"false")});i=n;requestAnimationFrame(function(){positionContent(slides[n])})}function stop(){if(timer){clearInterval(timer);timer=null}}function start(){stop();if(autoplay&&!matchMedia("(prefers-reduced-motion: reduce)").matches){timer=setInterval(function(){show(i+1)},delay)}}var prev=root.querySelector("[data-prev]");var next=root.querySelector("[data-next]");if(prev)prev.addEventListener("click",function(){show(i-1);start()});if(next)next.addEventListener("click",function(){show(i+1);start()});dots.forEach(function(dot){dot.addEventListener("click",function(){show(parseInt(dot.dataset.dot,10)||0);start()})});root.addEventListener("mouseenter",stop);root.addEventListener("mouseleave",start);root.addEventListener("focusin",stop);root.addEventListener("focusout",start);root.addEventListener("touchstart",function(event){startX=event.changedTouches[0].screenX},{passive:true});root.addEventListener("touchend",function(event){var dx=startX-event.changedTouches[0].screenX;if(Math.abs(dx)>45){show(dx>0?i+1:i-1);start()}},{passive:true});document.addEventListener("shopify:block:select",function(event){if(!event.detail||!event.detail.blockId)return;var selected=root.querySelector('[data-block-id="'+event.detail.blockId+'"]');if(!selected)return;stop();show(parseInt(selected.dataset.index,10)||0)});document.addEventListener("visibilitychange",function(){if(document.hidden)stop();else start()});start()}function initAll(){document.querySelectorAll('[id^="NDHero-"]').forEach(init)}if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",initAll,{once:true})}else{initAll()}document.addEventListener("shopify:section:load",initAll)})();

  } catch(e) { console.error(e); }
})();
})();
